import { gql } from "@apollo/client";

export const OPERATIONS_FILTER_QUERY = gql`
    query OperationsFilter {
        companies {
            items {
                key
                name
            }
        }
        channels {
            items {
                key
                name
            }
        }
        subBrands {
            items {
                key
                name
            }
        }
        brands {
            items {
                key
                name
            }
        }
        categories {
            items {
                key
                name
            }
        }
        routeToMarkets {
            items {
                key
                name
            }
        }
    }
`;


